export function validateEmail(email){
    const re = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
    return re.test(String(email)) ? null : 'Please enter a valid email';
}

export function validatePassword(password, password_conf, min_length = 6){
    if (password.length < min_length){
        return `Please enter a password (minimum ${min_length} characters)`;
    }
    return password === password_conf ? null : 'Password and confirmation does not match';
}

export function validateCustomerId(customer_id){
    if (customer_id.length < 3 || customer_id.length > 10){
        return `Please enter a Customer ID with a length between 3 and 10 characters and with characters from a-z only`;
    }
    return /[^a-z]+/.test(customer_id) ? 'The Customer ID may only consist of the characters a-z' : null;
}

export function userIsInRoles(user, roles){
    let mapping_roles = [];

    if (user && user.roles){
        mapping_roles = user.roles.filter((item) => roles.indexOf(item) >= 0);
    }

    return mapping_roles.length > 0;
}

export function userIsAdmin(user){
    return userIsInRoles(user, ['admin']);
}

export function userIsManager(user){
    return userIsInRoles(user, ['manager']);
}

export function userIsReviewer(user){
    return userIsInRoles(user, ['reviewer']);
}

export function isInteger(value){
    return Number.isInteger(value);
}

export function validId(id){
    // Validate if id is a researcher or a profile ID
    let is_profile_id = isInteger(parseInt(id));
    let researcher_id_frags = id.split('.');
    let is_researcher_id = researcher_id_frags.length === 3 && (researcher_id_frags[0] === 'ur' &&
        researcher_id_frags[2].length === 2 && isInteger(parseInt(researcher_id_frags[1])) &&
        isInteger(parseInt(researcher_id_frags[2])));
    return is_profile_id || is_researcher_id;
}

export default {
    validateEmail,
    validatePassword,
    userIsInRoles,
    userIsAdmin,
    userIsManager,
    userIsReviewer,
    isInteger,
    validId
};
